<template>
  <div class="container">
    <img
      class="header-img"
      @click="imgUrlBtn"
      src="http://tech001.oss-cn-hangzhou.aliyuncs.com/%E4%B8%AD%E5%BC%98%E6%B6%A6%E6%99%AF%E5%B0%8F%E7%A8%8B%E5%BA%8F/%E5%A4%B4%E5%9B%BE.jpg"
    />
    <div class="content-wrap">
      <div class="tabBox">
        <ul
          class="tab-item"
          v-for="(item, index) in menuData"
          :key="'menu-' + index"
          v-if="index <= 3"
          @click="menuDataBtn(item)"
        >
          <li class="tab-icon-wrap">
            <img :src="item.picture" alt="" />
          </li>
          <li class="tab-label">{{ item.label }}</li>
        </ul>

        <ul class="tab-item" @click="equityExchangeBtn">
          <li class="tab-icon-wrap">
            <svg
              t="1792043917954"
              class="icon"
              style="width: 56px; height: 56px; margin: -4px"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="7539"
            >
              <path
                d="M613.1 383.7c29.1-19.7 38.7-49 29.1-63-6.6-9.6-20.7-10.8-26.4-10.8-14 0-29.3 5.1-43.1 14.6-14.1 9.3-21.6 34.4-23.7 59.2 10.4 3 24.5 6.3 38 6.3 11.1 0 19.8-2.1 26.1-6.3zM429.2 383.5c6.3 4.2 15 6.3 26.1 6.3 13.7 0 27.5-3.3 38-6.3-2.1-24.5-9.6-49.6-23.7-59.2-13.7-9.2-29-14.3-43.1-14.3v-0.3c-5.7 0-19.8 0.9-26.4 10.8-6 9-3 20.3-0.9 26.6 4.8 13.4 15.6 26.8 30 36.4z"
                fill="#1D4ED8"
                p-id="7540"
              ></path>
              <path
                d="M512 64.7C265 64.7 64.7 265 64.7 512S265 959.3 512 959.3 959.3 759 959.3 512 759 64.7 512 64.7z m-15.7 689.5c0 3.3-2.7 6-6 6H351.9c-21.8 0-39.5-17.6-39.5-39.4v-109c0-3.3 2.7-6 6-6h172c3.3 0 5.9 2.6 5.9 5.9v142.5z m233.6-33.4c0 21.8-17.6 39.4-39.5 39.4H551.5c-3.3 0-6-2.7-6-6V611.7c0-3.3 2.7-5.9 6-5.9h166.4c6.6 0 12 5.4 12 12v103z m0.1-169.1c0 3.3-2.7 6-6 6H552c-3.3 0-6-2.7-6-6V411.8c-9.8-2.7-17.7-5.6-22.1-7.4-1.2-0.5-2.2-1.5-2.9-2.6-0.6 1.2-1.7 2.2-2.9 2.7-4.3 1.7-12.1 4.6-21.8 7.3v139.9c0 3.3-2.6 6-5.9 5.7h-172c-3.3 0-6-2.7-6-6V442.3c0-21.8 17.6-39.4 39.5-39.4h56.3c-35.8-27.2-50-70.1-31.1-97.7 10.5-15.2 28.7-23 49.4-23 18.9 0 39.9 6.2 58.4 19.2 26.8 18 34.2 57.1 36.1 81.2 2-24.1 9.5-63.3 36.1-81.3 18.9-12.8 39.8-19.1 58.7-19.1 21 0 39.3 7.7 49.1 22.9 19 27.8 4.9 70.9-31.6 98.1h57.2c21.8 0 39.5 17.6 39.5 39.4v109.1z"
                fill="#1D4ED8"
                p-id="7541"
              ></path>
            </svg>
          </li>
          <li class="tab-label">权益兑换</li>
        </ul>
      </div>

      <div class="tabBox" v-if="menuData.length > 4">
        <ul
          class="tab-item"
          v-for="(item, index) in menuData"
          :key="'menu-second-' + index"
          v-if="index > 3"
          @click="menuDataBtn(item)"
        >
          <li class="tab-icon-wrap">
            <img :src="item.picture" alt="" />
          </li>
          <li class="tab-label">{{ item.label }}</li>
        </ul>
      </div>

      <div class="recommendBox recommendBox--product">
        <p class="textTitle textTitle--product">产品推荐</p>
        <van-row style="text-align: center">
          <van-col
            span="12"
            v-for="(item, index) in centerImg"
            :key="'center-' + index"
            class="center-img-col"
          >
            <img :src="item.picture" alt="" @click="imgBtn(item)" />
          </van-col>
        </van-row>
      </div>

      <div class="recommendBox">
        <div class="recommend-header">
          <div class="textTitle">产品推文</div>
          <div class="more-link" @click="moreBtn">更多 ></div>
        </div>
        <div class="tweet-list">
          <div
            class="displayBox"
            v-for="(item, index) in recommendData"
            :key="'tweet-' + index"
            @click="productTweetsBtn(item)"
          >
            <div class="tweet-content">
              <div class="tweet-title">{{ item.title }}</div>
            </div>
            <div class="tweet-img-wrap">
              <img :src="item.img" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-safe"></div>
  </div>
</template>

<script>
import { Notify } from "vant";
import { getMenu } from "@/api/api";

// 简单 Base64 编码（手机号）
function encodeBase64(str) {
  return btoa(unescape(encodeURIComponent(str)));
}

export default {
  name: "home",
  data() {
    return {
      menuData: [],
      centerImg: [],
      titlePictureUrl: "",
      recommendData: [
        {
          title: "医保钱包是什么，怎么用？",
          img: "https://tech001.oss-cn-hangzhou.aliyuncs.com/%E5%8C%BB%E4%BF%9D%E9%92%B1%E5%8C%85.png",
          imageUrl:
            "https://tech001.oss-cn-hangzhou.aliyuncs.com/%E5%8C%BB%E4%BF%9D%E9%95%BF%E5%9B%BE.png",
        },
        {
          title: "九月健康月|做好“三减三健”把疾病预防“拦在前面”!",
          img: "https://mdcare.oss-cn-hangzhou.aliyuncs.com/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250911143906_1739_50.jpg",
          imageUrl:
            "https://mdcare.oss-cn-hangzhou.aliyuncs.com/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250911143907_1740_50.jpg",
        },
        {
          title: "肺结节离“癌”有多远？",
          img: "http://tech001.oss-cn-hangzhou.aliyuncs.com/%E4%B8%AD%E5%BC%98%E6%B6%A6%E6%99%AF%E5%B0%8F%E7%A8%8B%E5%BA%8F/%E7%BC%96%E7%BB%84%2012%403x.png",
          imageUrl:
            "http://tech001.oss-cn-hangzhou.aliyuncs.com/%E4%B8%AD%E5%BC%98%E6%B6%A6%E6%99%AF%E5%B0%8F%E7%A8%8B%E5%BA%8F/%E4%BA%A7%E5%93%81/%E4%BA%A7%E5%93%81%E6%8E%A8%E6%96%87%E5%86%85%E5%AE%B9/%E8%82%BA%E7%BB%93%E8%8A%82%E6%8E%A8%E6%96%87.jpg",
        },
      ],
    };
  },
  created() {
    getMenu({ productCode: "PC_DTY6UHJPUBG8" }).then((res) => {
      this.menuData = res.data.firstList;
      this.centerImg = res.data.lastList;
      this.titlePictureUrl = res.data.titlePictureUrl;
    });
    if (!localStorage.getItem("token")) {
      if (window.location.href.split("#login=")[1]?.split("?")[0]) {
        Notify({ type: "warning", message: "请先登录" });
        setTimeout(() => {
          this.$router.push({ name: "loginPage" });
        }, 800);
      }
    }
    if (window.location.search) {
      sessionStorage.setItem(
        "equityCode",
        window.location.search
          .split("equityCode=")[1]
          ?.split("&channelCode=")[0] || "",
      );
      sessionStorage.setItem(
        "channelCode",
        window.location.search.split("&channelCode=")[1] || "",
      );
    } else {
      const str = /^equityCode$/;
      if (str.test(window.location.href) === true) {
        sessionStorage.setItem(
          "equityCode",
          window.location.href
            .split("equityCode=")[1]
            ?.split("&channelCode=")[0] || "",
        );
        sessionStorage.setItem(
          "channelCode",
          window.location.href.split("&channelCode=")[1] || "",
        );
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === "login") {
        setTimeout(() => {
          window.location.href = window.location.href;
        }, 500);
      }
    });
  },
  methods: {
    equityExchangeBtn() {
      const phone = localStorage.getItem("phone") || "";
      const encoded = encodeBase64(phone);
      //健康权益兑换链接替换正式环境
      window.location.href = `https://mall.inf-health.com/healthRights/?phone=${encodeURIComponent(
        encoded,
      )}`;
    },
    moreBtn() {
      this.$router.push({ name: "home/productTweetsMore" });
    },
    menuDataBtn(item) {
      if (item.label === "体检预约") {
        window.location.href =
          "https://mobile.touchealth.com/common/login?pageId=1CblVfALsRj&channelNo=CH18392000&rentId=1621336003874783233";
      } else if (item.label === "团检定制") {
        this.$router.push({ name: "teamCustomized" });
      } else if (item.label === "报告解读") {
        if (localStorage.getItem("token")) {
          this.$router.push({ name: "reportInterpretation" });
        } else {
          Notify({ type: "warning", message: "请先登录" });
          setTimeout(() => {
            this.$router.push({ name: "login" });
          }, 800);
        }
      } else {
        this.$router.push({ name: "blankSpace" });
      }
    },
    imgUrlBtn() {
      if (localStorage.getItem("token")) {
        window.location.href =
          this.titlePictureUrl + "&token=" + localStorage.getItem("token");
      } else {
        Notify({ type: "warning", message: "请先登录" });
        setTimeout(() => {
          this.$router.push({ name: "login" });
        }, 800);
      }
    },
    productTweetsBtn(item) {
      this.$router.push({
        name: "home/productTweets",
        query: { imageUrl: item.imageUrl },
      });
    },
    imgBtn(item) {
      this.$router.push({
        name: "home/productRecommendations",
        query: { type: item.type },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  min-height: 100vh;
}
.header-img {
  width: 100%;
  height: auto;
  display: block;
}
.content-wrap {
  padding: 0 10px;
  box-sizing: border-box;
  margin-top: 10px;
}
.tabBox {
  background: #fff;
  border-radius: 10px;
  padding: 12px 5px;
  box-sizing: border-box;
  margin-bottom: 15px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
  justify-items: center;
  .tab-item {
    list-style: none;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .tab-icon-wrap {
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    img,
    svg {
      width: 100%;
      height: 100%;
      display: block;
    }
    img {
      object-fit: contain;
    }
  }
  .tab-label {
    font-size: 12px;
    color: #333;
    font-weight: 550;
    line-height: 1.3;
    text-align: center;
  }
}
.recommendBox {
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 15px;
}
.recommendBox--product {
  padding: 5px;
}
.center-img-col {
  padding: 2px;
  box-sizing: border-box;
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.textTitle {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
  display: block;
}
.textTitle--product {
  padding-left: 5px;
  margin-top: 10px;
}
.recommend-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  .textTitle {
    margin-top: 13px;
    margin-bottom: 0;
  }
  .more-link {
    color: #666;
    margin-right: 10px;
    cursor: pointer;
    font-size: 13px;
  }
}
.displayBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
  min-height: 100px;
  padding: 10px 0;
  box-sizing: border-box;
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
  .tweet-content {
    flex: 1;
    min-width: 0;
    padding-right: 15px;
    display: flex;
    align-items: center;
    .tweet-title {
      font-weight: bold;
      font-size: 15px;
      line-height: 1.4;
      margin: 0;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
  .tweet-img-wrap {
    width: 100px;
    flex-shrink: 0;
    padding-right: 5px;
    box-sizing: border-box;
    img {
      width: 100%;
      height: auto;
      max-height: 80px;
      object-fit: cover;
      display: block;
      border-radius: 6px;
    }
  }
}
.bottom-safe {
  height: 3rem;
}
img {
  width: 100%;
  height: auto;
  display: block;
}
.van-search__content--round {
  background-color: #fff !important;
}
</style>
